'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const link_types = require('./link.types.js');

var DOTTED = link_types.LinkDecorationTypes.DOTTED;
var retrieveColorTheme = function retrieveColorTheme(theme, type, prop) {
  var dark = theme && theme.dark || false;
  var colorTheme = dark ? 'dark' : type || 'primary';
  return link_types.LinkColors[colorTheme][prop];
};
var AnchorElement = styled__default.a.withConfig({
  displayName: "linkstyle__AnchorElement",
  componentId: "sc-1rt6me7-0"
})(["color:", ";text-decoration:", ";border-bottom:", ";font-family:", ";&:hover{border-bottom:", ";color:", ";}"], function (props) {
  return retrieveColorTheme(props.theme, props.type, 'base');
}, function (props) {
  return !(props.decoration === DOTTED) ? props.decoration : 'none';
}, function (props) {
  return props.decoration === DOTTED ? '1px dotted ' + retrieveColorTheme(props.theme, props.type, 'base') : 'none';
}, function (props) {
  var _props$theme;
  return (_props$theme = props.theme) === null || _props$theme === void 0 || (_props$theme = _props$theme.fonts) === null || _props$theme === void 0 || (_props$theme = _props$theme.family) === null || _props$theme === void 0 ? void 0 : _props$theme.primary;
}, function (props) {
  return props.decoration === DOTTED ? '1px dotted ' + retrieveColorTheme(props.theme, props.type, 'hover') : 'none';
}, function (props) {
  return retrieveColorTheme(props.theme, props.type, 'hover');
});

exports.AnchorElement = AnchorElement;
